import React, { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import SubscribeForm from './subscribe_form';
import type { ProductPlan, StripeProduct } from 'bundles/connect/types';

type Props = {
  freeTrialDays?: number;
  selectedPlan: ProductPlan;
  stripeProduct: StripeProduct;
  stripePublicKey: string;
}

export default function CheckoutNew({ freeTrialDays, selectedPlan, stripeProduct, stripePublicKey }: Props) {
  const stripePromise = useMemo(() => loadStripe(stripePublicKey), [stripePublicKey]);

  return (
    <Elements stripe={stripePromise}>
      <SubscribeForm freeTrialDays={freeTrialDays} selectedPlan={selectedPlan} stripeProduct={stripeProduct} />
    </Elements>
  );
}
